var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'asc-switch',
    _vm.isProjectZeus ? 'asc-switch--accent' : '',
    _vm.singleLine ? 'asc-switch--single-line' : '' ]},[_c('asc-label',{attrs:{"size":"sm","value":_vm.label}}),_c('v-switch',{attrs:{"label":_vm.getLabel,"disabled":_vm.$attrs.disabled,"hide-details":_vm.hideDetails},on:{"change":_vm.handleChange},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }